export default __webpack_public_path__ + "static/media/location-settings.16c22930.svg";